const B_1 = [
    {
        title: '合同统计',
        path: '/bidding/contract/tongji/list'
    }
]

export default {
    path: 'tongji',
    component: () => import(/*webpackChunkName: 'zbr-project'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/contract/tongji/list'),
            meta: {
                title: '合同统计',
                bread: B_1,
                topNav: true,
            },
        }
    ]
}
